@if (vm$ | async; as vm) {
  @if (vm.show) {
    <div class="page-header" data-testid="page-header">
      <nav class="crumbs" aria-label="Breadcrumb">
        @if (vm.domain) {
          <span class="domain">{{ vm.domain }}</span>
          <mat-icon class="sep">chevron_right</mat-icon>
        }
        <span class="title" data-testid="page-header-title">{{ vm.title }}</span>
      </nav>

      <span class="scope-chip" data-testid="page-header-scope">
        <mat-icon>{{ (activeGame$ | async) ? 'sports_esports' : 'public' }}</mat-icon>
        <span>{{ (activeGame$ | async)?.Name || 'All Games' }}</span>
      </span>
    </div>
  }
}
